import {
    svc_ob_genToken,
    svc_ob_addTestCustomer,
    svc_ob_addCustomer
} from '../services/external-openbanking.service';

import {
    svc_createOBCustomer,
    svc_getOBCustomerAccount,
    svc_getOBCustomerAccounts,
    svc_createOBCustomerAccount,
    svc_updateOBCustomerAccount,
} from '../services/internal-openbanking.service';

import {
    getOBCustomerSubmissionModel
} from '../models/OpenBankingCustomerModel';

import {
    getOBCustomerAccountClientModel
} from '../models/OpenBankingCustomerAccountModel';

import { OB_ACCOUNT_TYPE, ACCOUNT_TYPE } from '../constants/ACCOUNT_TYPE';

export const activateCustomer = async (
    username,
    obToken,
    auth0Token,
    userId,
    onSuccess,
) => {
    const {
        data: addCustomerResponse,
        error: addCustomerError
    } = await svc_ob_addTestCustomer(auth0Token, obToken, username);
    // await svc_ob_addCustomer(auth0Token, obToken, username);

    if (addCustomerError) {
        console.error('addCustomerError', addCustomerError);
        throw new Error(addCustomerError);
    }

    if (addCustomerResponse) {
        const createOBCustomerObj = getOBCustomerSubmissionModel(addCustomerResponse, obToken);

        const {
            data: createOBCustomerResponse,
            error: createOBCustomerError,
        } = await svc_createOBCustomer(auth0Token, userId, createOBCustomerObj);

        if (createOBCustomerError) {
            console.error('createOBCustomerError', createOBCustomerError);
            if (createOBCustomerError.status !== 409) {
                throw new Error(createOBCustomerError);
            }
        }

        const obCustomerObj = {
            ...createOBCustomerObj,
            obToken: obToken,
            id: createOBCustomerResponse.insertId,
        };

        if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(obCustomerObj);
        }

        return obCustomerObj;
    }
};

export const getInternalOBCustomerAccounts = async (
    obCustomer,
    auth0Token,
    userId,
    onSuccess,
    onFailure
) => {
    const { data, error } = await svc_getOBCustomerAccounts(auth0Token, userId, obCustomer.id);

    if (error) {
        if (onFailure && typeof onFailure === 'function') {
            return onFailure(error);
        }

        console.error('error', error);
        throw new Error(error);
    }

    const accountsModel = data.map((account) => {
        return getOBCustomerAccountClientModel(account)
    });
    
    accountsModel.forEach(account => {
        if (typeof account.data === 'string') {
            account.data = JSON.parse(account.data)
        }
    });

    if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(accountsModel);
    }

    return accountsModel;
}

export const getInternalOBCustomerAccount = async (
    obCustomer,
    auth0Token,
    userId,
    accountId,
    onSuccess,
    onFailure
) => {
    const { data, error } = await svc_getOBCustomerAccount(auth0Token, userId, obCustomer.id, accountId);

    if (error) {
        if (onFailure && typeof onFailure === 'function') {
            return onFailure(error);
        }

        console.error('error', error);
        throw new Error(error);
    }

    const accountModel = getOBCustomerAccountClientModel(data);

    if (typeof accountModel.data === 'string') {
        accountModel.data = JSON.parse(accountModel.data);
    }

    if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(accountModel);
    }

    return accountModel;
}

export const groupOBAccountsByType = (accounts) => {
    const groupedOBAccounts = accounts.reduce((acc, account) => {
        const type = OB_ACCOUNT_TYPE[account.data.type].mapping || ACCOUNT_TYPE.OTHER
        if (!acc[type]) {
            acc[type] = []
        }
        acc[type].push(account)
        return acc
    }, {})

    return groupedOBAccounts;
}

export const createOrUpdateAccounts = async (accessToken, freshAccounts, obCustomer, userId) => {
    const currentAccounts = await getInternalOBCustomerAccounts(
        obCustomer,
        accessToken,
        userId
    );
    const accountsToCreate = [];
    const accountsToUpdate = [];

    freshAccounts.forEach((freshAccount) => {
        const existingAccount = currentAccounts.find(
            (obAccount) => obAccount.accountId === parseInt(freshAccount.id)
        );

        if (existingAccount) {
            accountsToUpdate.push({
                existingAccount,
                freshAccount
            });
        } else {
            accountsToCreate.push(freshAccount);
        }
    });

    const createPromises = accountsToCreate.map((account) => {
        return svc_createOBCustomerAccount(accessToken, userId, {
            obCustomerId: obCustomer.id,
            accountId: parseInt(account.id),
            data: account,
            includeBalance: false,
        });
    });

    const updatePromises = accountsToUpdate.map((account) => {
        return svc_updateOBCustomerAccount(accessToken, userId, {
            obCustomerId: obCustomer.id,
            accountId: parseInt(account.existingAccount.accountId),
            data: account.freshAccount,
            includeBalance: account.existingAccount.includeBalance,
        });
    });

    await Promise.all(createPromises);
    await Promise.all(updatePromises);
};

export const generateAppToken = async (auth0Token) => {
    const { data, error } = await svc_ob_genToken(auth0Token);

    if (error) throw new Error(error);

    return data.token;
};

export const generateUserName = (email) => {
    return `${email}-${new Date().getTime()}`;
}